module.exports = __webpack_public_path__ + "static/img/ANDREW_SYMONDS.1e5315a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ANDREW_SYMONDS.jpg
// module id = gpRo
// module chunks = 0